import { render } from "./ReleaseDetails.vue?vue&type=template&id=0ad89322&scoped=true"
import script from "./ReleaseDetails.vue?vue&type=script&lang=js"
export * from "./ReleaseDetails.vue?vue&type=script&lang=js"

import "./ReleaseDetails.vue?vue&type=style&index=0&id=0ad89322&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ad89322"]])

export default __exports__